/**
 * Wellnesse reference PDP accordions — multiple panels can stay open (wellnesse-pdp-white.html).
 */
(function () {
  function initAccordions(root) {
    if (!root || root.dataset.wnsPdpAccordionInit === "1") return;
    root.dataset.wnsPdpAccordionInit = "1";

    root.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-wns-pdp-accordion-trigger]");
      if (!trigger || !root.contains(trigger)) return;

      var item = trigger.closest("[data-wns-pdp-accordion-item]");
      if (!item) return;

      var body = item.querySelector(".wns-pdp-accordion__body");
      if (!body) return;

      var open = trigger.classList.toggle("wns-pdp-accordion__header--open");
      body.classList.toggle("wns-pdp-accordion__body--open", open);
      if (open) {
        body.removeAttribute("hidden");
      } else {
        body.setAttribute("hidden", "");
      }
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  function boot() {
    document
      .querySelectorAll("[data-wns-pdp-accordions]")
      .forEach(initAccordions);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (evt) {
    var section = evt.target;
    if (!section) return;
    section
      .querySelectorAll("[data-wns-pdp-accordions]")
      .forEach(function (el) {
        delete el.dataset.wnsPdpAccordionInit;
        initAccordions(el);
      });
  });
})();
